import { createContext, useContext } from "react"

export interface StepStackContextValue {
    orderedIds: string[]
    currentItemId: string | null
    maxClickableItemId: string | null
    errorItemIds: Set<string>
    navigateTo: (id: string) => void
    registerItem: (id: string) => () => void
    transitionDurationMS: number
}

export const StepStackContext = createContext<StepStackContextValue | undefined>(undefined)
StepStackContext.displayName = "StepStackContext"

export function useStepStack(): StepStackContextValue {
    const context = useContext(StepStackContext)
    if (!context) {
        throw new Error("useStepStack must be used within a StepStack.Root")
    }
    return context
}

export function useStepStackOptional(): StepStackContextValue | undefined {
    return useContext(StepStackContext)
}
